import {
  ArticleOutlined,
  AssignmentOutlined,
  DriveFileRenameOutlineOutlined,
  HeadsetMicOutlined,
  OndemandVideoOutlined,
  QuizOutlined,
  StairsOutlined,
  WebOutlined,
} from '@mui/icons-material';

import { Tooltip } from '@mui/material';
type Props = {
  type: string;
};

const CustomContentTypeIcon = ({ type }: Props) => {
  let icon;
  switch (type) {
    case 'Video':
      icon = (
        <OndemandVideoOutlined
          sx={{
            cursor: 'pointer',
          }}
        />
      );
      break;
    case 'TopicQuiz':
    case 'TopicUnitTest':
      icon = <QuizOutlined sx={{ cursor: 'pointer' }} />;
      break;
    case 'Article':
      icon = <ArticleOutlined sx={{ cursor: 'pointer' }} />;
      break;
    case 'Course Challenge':
      icon = <StairsOutlined sx={{ cursor: 'pointer' }} />;
      break;
    case 'Exercise':
      icon = <DriveFileRenameOutlineOutlined sx={{ cursor: 'pointer' }} />;
      break;
    case 'Meeting':
      icon = (
        <HeadsetMicOutlined
          sx={{
            cursor: 'pointer',
          }}
        />
      );
      break;
    case 'Supporting':
      icon = <WebOutlined sx={{ cursor: 'pointer' }} />;
      break;
    default:
      icon = (
        <AssignmentOutlined
          sx={{
            cursor: 'pointer',
          }}
        />
      );
  }

  return <Tooltip title={type}>{icon}</Tooltip>;
};

export default CustomContentTypeIcon;
